import React, { useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Header from "../components/Header";
import Footer from "../components/Footer";

const ForgotPassword = () => {

  const navigate = useNavigate();

  const [step, setStep] = useState(1);

  const [userName, setUserName] = useState("");

  const [resetToken, setResetToken] =
    useState("");

  const [maskedEmail, setMaskedEmail] =
    useState("");

  const [otp, setOtp] = useState("");

  const [newPassword, setNewPassword] =
    useState("");

  const [showPassword, setShowPassword] =
    useState(false);

  const [isLoading, setIsLoading] =
    useState(false);

  const sendOtp = async (e) => {

    e.preventDefault();

    setIsLoading(true);

    try {

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/auth/forget-password/`,
        {
          user_name: userName,
        }
      );

      if (response.data.status === 200) {

        setResetToken(
          response.data.data.reset_token
        );

        setMaskedEmail(
          response.data.data.masked_email
        );

        toast.success(
          response.data.message
        );

        setStep(2);
      }

    } catch (err) {

      toast.error(
        err?.response?.data?.message ||
        "Failed to send OTP"
      );

    } finally {

      setIsLoading(false);

    }

  };

  const resetPassword = async (e) => {

    e.preventDefault();

    setIsLoading(true);

    try {

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/auth/reset-password/`,
        {
          reset_token: resetToken,
          otp: otp,
          new_password: newPassword,
        }
      );

      if (response.data.status === 200) {

        toast.success(
          "Password updated successfully"
        );

        setTimeout(() => {
          navigate("/login");
        }, 1500);

      }

    } catch (err) {

      toast.error(
        err?.response?.data?.message ||
        "Failed to reset password"
      );

    } finally {

      setIsLoading(false);

    }

  };

  return (
    <>
      <Header />

      <style>{`
        body{
          margin-top:150px;
        }

        .forgot-container{
          min-height:70vh;
          display:flex;
          justify-content:center;
          align-items:center;
          padding:40px 20px;
        }

        .forgot-card{
          width:100%;
          max-width:420px;
          background:#fff;
          border-radius:15px;
          overflow:hidden;
          box-shadow:0 20px 60px rgba(0,0,0,.2);
        }

        .forgot-header{
          background:linear-gradient(
            135deg,
            #6B2A00 0%,
            #8B3A00 100%
          );

          color:white;
          padding:30px;
          text-align:center;
        }

        .forgot-body{
          padding:30px;
        }

        .form-control{
          margin-bottom:15px;
          padding:12px;
        }

        .submit-btn{
          width:100%;
          border:none;
          color:white;
          padding:12px;
          border-radius:8px;
          background:linear-gradient(
            135deg,
            #6B2A00 0%,
            #8B3A00 100%
          );
        }
      `}</style>

      <div className="forgot-container">

        <div className="forgot-card">

          <div className="forgot-header">

            <h2>
              Forgot Password
            </h2>

            <p>
              Reset your account password
            </p>

          </div>

          <div className="forgot-body">

            {step === 1 && (

              <form onSubmit={sendOtp}>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Username"
                  value={userName}
                  onChange={(e) =>
                    setUserName(
                      e.target.value
                    )
                  }
                  required
                />

                <button
                  type="submit"
                  className="submit-btn"
                  disabled={isLoading}
                >
                  {isLoading
                    ? "Sending..."
                    : "Send OTP"}
                </button>

              </form>

            )}

            {step === 2 && (

              <form
                onSubmit={
                  resetPassword
                }
              >

                <div
                  className="alert alert-success"
                >
                  OTP sent to
                  <br />
                  <strong>
                    {maskedEmail}
                  </strong>
                </div>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) =>
                    setOtp(
                      e.target.value
                    )
                  }
                  required
                />

                <div
                  className="position-relative"
                >

                  <input
                    type={
                      showPassword
                        ? "text"
                        : "password"
                    }
                    className="form-control"
                    placeholder="New Password"
                    value={
                      newPassword
                    }
                    onChange={(e) =>
                      setNewPassword(
                        e.target.value
                      )
                    }
                    required
                  />

                  <button
                    type="button"
                    style={{
                      position:
                        "absolute",
                      right: 10,
                      top: 10,
                      border: "none",
                      background:
                        "transparent",
                    }}
                    onClick={() =>
                      setShowPassword(
                        !showPassword
                      )
                    }
                  >
                    👁
                  </button>

                </div>

                <button
                  type="submit"
                  className="submit-btn"
                  disabled={isLoading}
                >
                  {isLoading
                    ? "Updating..."
                    : "Reset Password"}
                </button>

              </form>

            )}

          </div>

        </div>

      </div>

      <ToastContainer />

      <Footer />
    </>
  );
};

export default ForgotPassword;

